module.exports = __webpack_public_path__ + "static/odg-white-logo-7376d1cff7a98e8ac26e8fcc3b0679fd.svg";